import React from 'react';
import PropTypes from 'prop-types';

/** Components */
import {
  StyledTrafficContainer,
  StyleWidgetIcon,
  StyledText,
  StyledTimeWrap,
  StyledTrafficWrap
} from './style';
import WidgetMiniUpdate from '../../../../core/WidgetMini/WidgetMiniUpdate';

/** Icons */
import { Car } from '../../../../../../assets/images';

/** Constants */
const getTime = secs => {
  let timeTxt = '';
  let minutes = Math.trunc(secs / 60);
  const hours = Math.trunc(minutes / 60);
  minutes = Math.trunc(minutes % 60);

  if (hours < 1) {
    timeTxt = `${minutes}`;
  } else {
    timeTxt = `${hours}h ${minutes}`;
  }

  return timeTxt;
};

const LEVELS = {
  LIGHT: 'Estable',
  MODERATE: 'Moderado',
  HEAVY: 'Complicado'
};

const TrafficInfo = ({
  toHome,
  duration,
  trafficStatus,
  getTraffic,
  lastUpdate
}) => (
  <StyledTrafficContainer>
    {toHome ? (
      <StyledText className="TrafficInfo-text">
        Tardo en llegar a casa
      </StyledText>
    ) : (
      <StyledText className="TrafficInfo-text">
        Tardo en llegar al trabajo
      </StyledText>
    )}
    <StyledTimeWrap>
      <StyleWidgetIcon svg={Car} size="l" color="dark" />
      {getTime(duration)}’
    </StyledTimeWrap>
    <StyledTrafficWrap>
      Tráfico:
      {` `}
      <strong>{` ${LEVELS[trafficStatus]}`}</strong>
    </StyledTrafficWrap>
    <WidgetMiniUpdate update={lastUpdate} onInfo={getTraffic} />
  </StyledTrafficContainer>
);

TrafficInfo.propTypes = {
  toHome: PropTypes.bool,
  duration: PropTypes.number,
  trafficStatus: PropTypes.string,
  getTraffic: PropTypes.func,
  lastUpdate: PropTypes.string
};

export default TrafficInfo;
